import { render } from "./AttachedDocuments.vue?vue&type=template&id=3749ef2b"
import script from "./AttachedDocuments.vue?vue&type=script&lang=js"
export * from "./AttachedDocuments.vue?vue&type=script&lang=js"

import "./AttachedDocuments.vue?vue&type=style&index=0&id=3749ef2b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__